import React from 'react';
import { styled } from 'styled-components';
import { Colors, hexToRGB } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TeaserOverlayInfo = ({
  icon,
  text
}) => /*#__PURE__*/_jsxs(Shadow, {
  children: [/*#__PURE__*/_jsx(IconWrapper, {
    icon: icon,
    color: Colors.GREY_d2d2d2
  }), /*#__PURE__*/_jsx(Text, {
    children: text
  })]
});
const Text = styled.span.withConfig({
  displayName: "TeaserOverlayInfo__Text",
  componentId: "sc-1usarea-0"
})(["margin-top:16px;", ";color:", ";width:60%;text-align:center;", "{", ";margin-top:8px;width:90%;}"], Fonts.regular(16), Colors.GREY_d2d2d2, Viewports.for('small'), Fonts.regular(11));
const Shadow = styled.div.withConfig({
  displayName: "TeaserOverlayInfo__Shadow",
  componentId: "sc-1usarea-1"
})(["position:absolute;left:0;top:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;padding-bottom:8px;background:", ";svg{font-size:36px;", "{font-size:30px;}}"], hexToRGB(Colors.GREY_1a1a1a, 0.7), Viewports.for('small'));